export default function Pagination({ page, pageSize, total, onPageChange, onPageSizeChange }) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const start = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);

  const pageNumbers = [];
  const windowSize = 2;
  for (let p = Math.max(1, page - windowSize); p <= Math.min(totalPages, page + windowSize); p++) {
    pageNumbers.push(p);
  }

  return (
    <div className="pagination-footer">
      <div>
        Showing {start}-{end} of {total}
      </div>
      <div className="pagination-controls">
        <select value={pageSize} onChange={e => onPageSizeChange(Number(e.target.value))} style={{ marginRight: 12 }}>
          <option value={10}>10 / page</option>
          <option value={25}>25 / page</option>
          <option value={50}>50 / page</option>
          <option value={100}>100 / page</option>
        </select>
        <button disabled={page <= 1} onClick={() => onPageChange(page - 1)}>‹</button>
        {pageNumbers[0] > 1 && <span style={{ padding: '0 4px' }}>…</span>}
        {pageNumbers.map(p => (
          <button key={p} className={p === page ? 'active' : ''} onClick={() => onPageChange(p)}>{p}</button>
        ))}
        {pageNumbers[pageNumbers.length - 1] < totalPages && <span style={{ padding: '0 4px' }}>…</span>}
        <button disabled={page >= totalPages} onClick={() => onPageChange(page + 1)}>›</button>
      </div>
    </div>
  );
}
